import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CreateProcessMapHubPage } from './CreateProcessMapHubPage';

const CreateProcessMapHubPageBridge = react2angular(
  CreateProcessMapHubPage,
  []
);
export { CreateProcessMapHubPageBridge };
